import client from "./client";

export const fetcher = (url: string) => client.get(url).then((res) => res.data);

export const paramFetcher = (keys: string[]) =>
  client.get(keys.join("/")).then((res) => res.data);
